import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Social from './Social';
import StoreSelector from './store-selector/StoreSelector';
import AddToCart from './add-to-cart/AddToCart';
import AddToWishlist from './add-to-wishlist/AddToWishlist';

import './TopBarRight.css';

class TopBarRight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sceneSelectorActive: false,
            cartActive: false,
            wishListActive: false
        };
    }

    showSceneSelector = (type) => {
        this.setState({ sceneSelectorActive: type })
    }

    showCartActive = (type) => {
        this.setState({ cartActive: type })
    }

    showWishListActive = (type) => {
        this.setState({ wishListActive: type })
    }

    render() {
        const { showStoreSelector, moveTopRightBarToBottomLeft, setQuizVisibility } = this.props;
        const { sceneSelectorActive, cartActive, wishListActive } = this.state;
        let topBarRightRender = (<React.Fragment />);
        if (showStoreSelector) {
            topBarRightRender = (
                <StoreSelector sceneSelectorActive={sceneSelectorActive} cartActive={cartActive}
                    showCartActive={this.showCartActive}
                    showSceneSelector={this.showSceneSelector}
                    showWishListActive={this.showWishListActive}
                    setQuizVisibility={setQuizVisibility} />
            );
        } /* else {
            topBarRightRender = (
                <Social socialReversed={true} />
            );
        } */
        const id = moveTopRightBarToBottomLeft ? 'topBarRightAtBottomLeft' : 'topBarRight';
        return (
            <div id={id}>
                <div className="flex-left">
                    {topBarRightRender}
                    <AddToCart
                        sceneSelectorActive={sceneSelectorActive}
                        cartActive={cartActive}
                        showCartActive={this.showCartActive}
                        showWishListActive={this.showWishListActive}
                        showSceneSelector={this.showSceneSelector}
                        wishListActive={wishListActive}
                        showWishListActive={this.showWishListActive}
                        currentLanguage={this.props.currentLanguage}
                    />
                    <AddToWishlist
                        sceneSelectorActive={sceneSelectorActive}
                        wishListActive={wishListActive}
                        showWishListActive={this.showWishListActive}
                        showCartActive={this.showCartActive}
                        cartActive={cartActive}
                        showSceneSelector={this.showSceneSelector}
                        currentLanguage={this.props.currentLanguage}
                    />
                </div>
            </div>
        );
    }
}

TopBarRight.propTypes = {
    showStoreSelector: PropTypes.bool,
    moveTopRightBarToBottomLeft: PropTypes.bool,
    setQuizVisibility: PropTypes.func
};

export default TopBarRight;
